// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__2KmGq","icon":"SortAdornment_icon__2_Toz","up":"SortAdornment_up__2ZMdo","down":"SortAdornment_down__1AG7r","active":"SortAdornment_active__389Dw"};